// @flow
import typeof CustomErrorType from '../../server/shared/errors/CustomError';
import * as constants from '../constants/errorConstants';
import type { Action } from '../types';

const initialState = null;

export type State = null | CustomErrorType;

export default function error(state: State = initialState, action: Action): State {
    // if(!action.silentError) {
    //     return action.error;
    // }

    switch(action.type) {
        case constants.SET_ERROR: {
            return error;
        }

        case constants.CLEAR_ERROR:
            return null;


        default:
            return state;
    }
}